import React from 'react';
import { withStyles } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import withWidth from '@material-ui/core/withWidth';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import iconAttention from '../../Resources/Images/icon-attention.svg';
import { lightRed, red } from '../../Constants/Colors';
import clsx from 'clsx';

const styles = (theme) => ({
  dialogTitleRoot: {
    fontSize: '1.5rem',
    fontWeight: 400,
  },

  TypographyCaption: {
    fontSize: 12,
    lineHeight: 1.7,
  },
  icon: {
    width: '36px',
    height: '25px',
    padding: '2px',
    minWidth: '0px',
    filter: `invert(1)`,
  },
  errorResult: {
    background: lightRed,
    border: `1px solid ${red}`,
    color: red,
    borderRadius: '5px',
    fontSize: 16,
    lineHeight: 1.7,
    textAlign: 'center',
    display: 'flex',
  },
  errorResultIcon: {
    float: 'left',
  },
  errorIconWrapper: {
    padding: '36px 10px',
    background: red,
  },
  errorMessageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: red,
    fontWeight: 'bold',
    paddingLeft: '40px',
  },
  codeFieldWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 32,
  },
  codeField: {
    fontSize: '26px',
    borderRadius: 0,
    height: 40,
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      height: 56,
      width: '100%',
    },
    '& .MuiInputBase-root': {
      borderRadius: 0,
    },
  },
  codeFieldInput: {
    fontSize: '15px',
    lineHeight: '18px',
    textAlign: 'center',
    height: 20,
    padding: '10px 16px',
    minWidth: 320,
    [theme.breakpoints.down('xs')]: {
      padding: '0 5px',
      height: 56,
      minWidth: 50,
    },
  },
  activeButton: {
    padding: '6px 15px',
  },
});

interface Props {
  onLoadClick: () => void;
  onClose: () => void;
  onCodeChange: () => void;
  loadCode: string;
  errorMessage: string;
  classes: object;
  workInProgress: boolean;
  show: boolean;
}

const LoadConfiguration: React.FC<Props> = (props) => {
  const { classes, workInProgress, onLoadClick, errorMessage, show, onClose, loadCode } = props;
  const onChange = (e) => {
    props.onCodeChange(e.target.value);
  };

  return (
    <CustomDialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t('loadConfiguration.dialogTitle')}
      onCancel={onClose}
    >
      <DialogContent>
        {workInProgress && (
          <Typography
            variant="body1"
            classes={{ root: classes.TypographyCaption }}
            id="alert-dialog-description"
          >
            {t('loadConfiguration.loadingInProgress')}
          </Typography>
        )}
        {!workInProgress && (
          <React.Fragment>
            <Typography
              variant="body1"
              classes={{ root: classes.TypographyCaption }}
              id="alert-dialog-description"
            >
              {t('loadConfiguration.enterCode')}
            </Typography>
            <div className={classes.codeFieldWrapper}>
              <TextField
                className={classes.codeField}
                value={loadCode}
                variant={'outlined'}
                onChange={onChange}
                placeholder={t('loadConfiguration.codeInputPlaceholder')}
                InputProps={{
                  classes: {
                    input: classes.codeFieldInput,
                  },
                }}
              />
            </div>
          </React.Fragment>
        )}
        {errorMessage && (
          <div className={classes.errorResult}>
            <div className={classes.errorIconWrapper}>
              <img src={iconAttention} className={clsx(classes.errorResultIcon, classes.icon)} />
            </div>
            <div className={classes.errorMessageWrapper}>{t(errorMessage)}</div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <AnalyticsWrapper targetId="load_request" data={loadCode}>
          <MainButton
            onClick={onLoadClick}
            variant="contained"
            size="medium"
            className={classes.activeButton}
          >
            {t('loadConfiguration.loadButton')}
          </MainButton>
        </AnalyticsWrapper>
      </DialogActions>
    </CustomDialog>
  );
};

export default withWidth()(withStyles(styles, { name: 'LoadConfiguration' })(LoadConfiguration));
